import Modal from "react-bootstrap/Modal";
import { GrClose } from "react-icons/gr";
import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from "react-icons/io";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.scss";
import { pathMaker } from "../../utilities/helperFunction";
export default function ProductModal({
  show,
  productModalData,
  closeModal,
  name,
  type = "product",
  clickOnProduct,
}) {
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <IoMdArrowDroprightCircle
        className={className}
        style={{
          ...style,
          display: "block",
          color: "#601111",
          width: 25,
          height: 25,
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <IoMdArrowDropleftCircle
        className={className}
        style={{
          ...style,
          display: "block",
          color: "#601111",
          width: 25,
          height: 25,
        }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    appendDots: (dots) => (
      <div
        style={{
          backgroundColor: "#ddd",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <div
          className="d-flex img-list-container"
          style={{ overflowX: "auto" }}
        >
          {" "}
          {dots}{" "}
        </div>
      </div>
    ),
    customPaging: (i) => (
      <div className="mx-2 img-list-slick">
        <div
          onClick={() =>
            clickOnProduct(
              +productModalData[i].main_product_id,
              +productModalData[i].id
            )
          }
        >
          {" "}
          <img
            src={
              type == "product"
                ? pathMaker(productModalData[i].main_img_src)
                : productModalData[i].src
            }
          />
          <div className="text-center my-2" style={{ fontSize: 13 }}>
            {type == "product" ? productModalData[i].title : ""}
          </div>
        </div>
      </div>
    ),
  };
  return (
    <>
      <Modal show={show} onHide={closeModal} centered size="lg">
        <Modal.Body>
          <Modal.Header>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>
              {" "}
              {name}
            </span>

            <GrClose
              onClick={() => closeModal()}
              style={{ cursor: "pointer" }}
            />
          </Modal.Header>

          <div className="product-modal">
            <Slider {...settings}>
              {productModalData?.map((p, i) => {
                return (
                  <div key={`mainProduct${i}`}>
                    <div className="text-center my-2">
                      {type == "product" ? p.title : ""}
                    </div>
                    <img
                      src={
                        type == "product" ? pathMaker(p.main_img_src) : p.src
                      }
                      className="img-slider"
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
